import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, toRefs, inject } from "vue";
import { useStore } from "vuex";
import { Booking } from "@/models";
import moment from "moment-timezone";
import { DxDateBox } from "devextreme-vue/date-box";

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduledDateSelect',
  props: {
    pvm: {},
    changesdatepvmid: {}
  },
  emits: ["schedulatedatepvmselected"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const actProperty: any = inject("actProperty");
const propertyvisitmanagement = computed(
  () => store.getters["propertyvisitmanagement/getBookingsData"]
);
const props = __props;
const emit = __emit;
const scheduledDateSelect = ref<{ [key: string]: HTMLElement | undefined }>({});
const setBookingsData = (data: Booking[]) =>
  store.commit("propertyvisitmanagement/setBookings", data);
const { pvm, changesdatepvmid } = toRefs(props);
const changeSDateReport = () => {
  emit("schedulatedatepvmselected", pvm.value.id);

  const dropdown = scheduledDateSelect.value[`descheduleddate-${pvm.value.id}`] as any;
  if (dropdown) {
    dropdown.activate();
  }
};
const setScheduledDate = async (id: string, $event: any) => {  
  if($event === 'Invalid date' || $event === null) return;
  const pmIndex = propertyvisitmanagement.value.findIndex(
    (r: Booking) => r.id === id
  );
  propertyvisitmanagement.value[pmIndex].scheduleddate =
    moment($event).format("YYYY-MM-DD[T]HH:mm");
  setBookingsData(propertyvisitmanagement.value);
  pvm.value.id = id;
  emit("schedulatedatepvmselected", "");
};
const closeDropdown = () => {
  emit("schedulatedatepvmselected", "");
};
const scheduleddate = ref("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onFocusout: closeDropdown }, [
    _withDirectives(_createVNode(_unref(DxDateBox), {
      class: "form-control height-43",
      value: scheduleddate.value,
      "display-format": "dd/MM/yyyy",
      type: "date",
      "picker-type": "calendar",
      "apply-value-mode": "instantly",
      calendarOptions: { firstDayOfWeek: 1 },
      onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (setScheduledDate(_unref(pvm).id, $event.value))),
      ref: 'scheduledDateSelect-' + _unref(pvm).id
    }, null, 8, ["value"]), [
      [_vShow, _unref(changesdatepvmid) === _unref(pvm).id]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'transparent-text': !_unref(pvm).scheduleddate }),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSDateReport()))
    }, _toDisplayString(_unref(pvm).scheduleddate
          ? _unref(actProperty).formatDateForDisplay(_unref(pvm).scheduleddate)
          : "Select"), 3), [
      [_vShow, _unref(changesdatepvmid) !== _unref(pvm).id]
    ])
  ], 32))
}
}

})